/* import __COLOCATED_TEMPLATE__ from './legal-warning.hbs'; */
import Component from '@glimmer/component';
import styles from './legal-warning.module.scss';

export default class RequestPrescreenerLegalWarning extends Component {
  styles = styles;
}
